import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Row, Col, Form, Checkbox } from 'antd';
import { Button } from '@/components/ui/Button';
import { Title } from '@/components/Typography';
import * as S from '../styles';

interface SettingsModalProps {
	isOpen?: boolean;
	isDisabled?: boolean;
	isLoadingOnSubmit?: boolean;
	onClose?: () => void;
	onSubmit?: () => void;
}

export function SettingsModal({
	isOpen = false,
	isDisabled = false,
	isLoadingOnSubmit = false,
	onClose,
	onSubmit
}: Readonly<SettingsModalProps>): JSX.Element {
	const checkboxOptions = [
		{ id: 0, value: 'most_dangerous_tasks', description: 'Tasks with the most serious risks' },
		{ id: 1, value: 'comment', description: 'Comments' },
		{ id: 2, value: 'task_risk', description: 'Task risk' }
	];

	return (
		<S.ModalWrapper open={isOpen} onCancel={onClose} width={550} footer={false} centered>
			<Row justify="center">
				<Col span={24} style={{ textAlign: 'center' }}>
					<Title level={2}>PDF</Title>
					<p style={{ fontSize: 18, fontWeight: 400 }}>
						{I18n.get('Select the items you want to present in your document')}
					</p>
				</Col>
				<Col span={22}>
					<Row justify="center" gutter={[10, 0]} style={{ marginTop: '1rem', marginBottom: '1rem' }}>
						<Col span={24}>
							<Form.Item name="pdf_parameters">
								<Checkbox.Group style={{ width: '100%' }} disabled={isDisabled}>
									<Row gutter={[0, 14]}>
										{checkboxOptions.map((item) => (
											<Col key={item.id} span={24}>
												<Checkbox value={item.value}>
													<strong style={{ fontSize: 18, fontWeight: 600 }}>
														{I18n.get(item.description)}
													</strong>
												</Checkbox>
											</Col>
										))}
									</Row>
								</Checkbox.Group>
							</Form.Item>
						</Col>
					</Row>
					<Row justify="center">
						<Col span="auto" style={{ marginRight: '1rem' }}>
							<Button onClick={onClose}>{I18n.get('Cancel')}</Button>
						</Col>
						<Col span="auto">
							<Button type="primary" loading={isLoadingOnSubmit} onClick={onSubmit}>
								{I18n.get('Generate document')}
							</Button>
						</Col>
					</Row>
				</Col>
			</Row>
		</S.ModalWrapper>
	);
}
